import { AuthUserPerfilId } from 'store/modules/auth/IAuthUserPerfil';

export interface JWTAssessorJson {
  sub: string;
  roles: string[];
  amr: string[];
  iss: string;
  nonce: string;
  sid: string;
  aud: string;
  SicrediSituacao: string;
  azp: string;
  name: string;
  exp: number;
  iat: number;
  email: string;
}

export interface JWTAssociadoJson {
  acr: string;
  aud: string;
  auth_time: number;
  azp: string;
  email_verified: boolean;
  given_name: string;
  iss: string;
  jti: string;
  name: string;
  preferred_username: string;
  relation: Array<AuthUserPerfilId>;
  scope: string;
  session_state: string;
  typ: string;
  sub: string;
  exp: number;
  iat: number;
}

const brokeJWTAccessToken = (token: string): any => {
  try {
    const base64Url: string = token.split('.')[1];
    const base64: string = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload: string = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    return null;
  }
};

export const getParsedJWTAssessorAccessToken = (
  token: string
): JWTAssessorJson | null => {
  const jwt = brokeJWTAccessToken(token);
  return jwt ? (jwt as JWTAssessorJson) : null;
};

export const getParsedJWTAssociadoAccessToken = (
  token: string
): JWTAssociadoJson | null => {
  const jwt = brokeJWTAccessToken(token);
  return jwt ? (jwt as JWTAssociadoJson) : null;
};
